import { createAction } from '@reduxjs/toolkit';
import { RequestActionTypes } from './types';

export const clearRequestStackAction = createAction(RequestActionTypes.CLEAR_REQUEST_STACK);
